import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'inside-out/components/shared/link';

import {
	wrapperStyle,
	wrapperInnerStyle,
	leftStyle,
	rightStyle,
	topTextStyle,
	bottomTextStyle,
	buttonStyle,
} from './styles';

const InPagePromptComponent = ({ topText, bottomText, cta, inline }) => (
	<div className={wrapperStyle(inline)}>
		<div className={wrapperInnerStyle}>
			<div className={leftStyle}>
				<p className={topTextStyle}>{topText}</p>
				<p className={bottomTextStyle}>{bottomText}</p>
			</div>
			<div className={rightStyle}>
				<Link to={cta.to} className={buttonStyle}>
					<span>{cta.text}</span>
				</Link>
			</div>
		</div>
	</div>
);

InPagePromptComponent.defaultProps = {
	inline: false,
};

InPagePromptComponent.propTypes = {
	topText: PropTypes.string,
	bottomText: PropTypes.string,
	cta: PropTypes.object,
	inline: PropTypes.bool,
};

export const InPagePrompt = InPagePromptComponent;



// WEBPACK FOOTER //
// ./src/components/shared/inPagePrompt/component.js